/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

// these constants are converted from its Mex App counterpart, which should have the most up-to-date values.
// see https://gitlab.myteksi.net/mobile/monorepo/-/blob/master/apps/mex/deliveries_modules/module/mav/lib/util/mav_constant.dart
export const MavConstant = {
  // Appease Types
  appeaseTypeAll: 400,
  appeaseTypeIssuedVoucher: 403,
  appeaseTypeRefundAndIssuedVoucher: 404,
  appeaseTypeRefunded: 402,
  appeaseTypeNotRefunded: 401,
  chargeBackFilter: 501,
  noChargeBackFilter: 0,
  appeaseTypeMexIssuedVoucher: 701,
  appeaseTypeMexIssuedVoucherRedeemed: 702,
  appeaseTypeMexIssuedVoucherExpired: 703,

  // Incident Metrics
  incidentMetricAll: 300,
  incidentMetricSafety: 301,
  incidentMetricQuality: 302,
  incidentMetricCancellation: 303,
  incidentMetricTimeExceed: 304,

  // Appeal Status
  appealStatusNoEvent: 0,
  noAppeal: 500,
  appealSent: 501, // appeal sent or appeal in progress
  appealApproved: 502,
  appealRejected: 503,
  appealPartialApproved: 504,
  appealOngoing: 505,

  // Clawback
  clawbackFinish: 602,

  // Filter Types
  filterTypeTimeSpan: "TIMESPAN" as const,
  filterTypeMetric: "METRIC" as const,
  filterTypeAppeaseType: "APPEASETYPE" as const,

  // Feature Name
  mavFeatureName: "merchantAppeasementVoucher" as const,

  // Incident Severe Grouping
  severeFoodSafety: 1001,
  lightFoodSafety: 1002,
  otherQuantityIssue: 1003,
  missingOrWrongItem: 1004,

  // Incident Grouping
  mavIncidentGroupingAllergy: 1001,
  mavIncidentGroupingFoodContamination: 1002,
  mavIncidentGroupingPoisoning: 1003,
  mavIncidentGroupingUndercooked: 1004,
  mavIncidentGroupingSpoiledFood: 1005,
  mavIncidentGroupingExpiredProduct: 1006,
  mavIncidentGroupingSeriousCrime: 1007,
  mavIncidentGroupingHarassment: 1008,
  mavIncidentGroupingAppAndInStorePricingDontMatch: 1009,
  mavIncidentGroupingItemIsntOrDoesntWorkAsAdvertised: 1010,
  mavIncidentGroupingSpillageMessyOrDamagedPackaging: 2001,
  mavIncidentGroupingFakeCompletionOrder: 2002,
  mavIncidentGroupingNotFollowingCustomerRequirements: 2003,
  mavIncidentGroupingSolicitingCustomers: 2004,
  mavIncidentGroupingColdFood: 2005,
  mavIncidentGroupingSoggyFood: 2006,
  mavIncidentGroupingFoodNotTasty: 2007,
  mavIncidentGroupingMissingOrWrongItems: 2008,
  mavIncidentGroupingStoreTooBusyClosingOrClosed: 3001,
  mavIncidentGroupingProductUnavailable: 3002,
  mavIncidentGroupingExceedsTargetPrepTime: 4001,

  // Incident Alias
  mavIAFatalFoodAllergy: 1001001,
  mavIAFoodAllergyRequiringMedicalAssistance: 1001002,
  mavIAMildFoodAllergyWithoutMedicalAssistance: 1001003,
  mavIAFatalHazardousContamination: 1002001,
  mavIAHazardousContaminationRequiringMedicalAssistance: 1002002,
  mavIAHazardousContaminationWithoutMedicalAssistance: 1002003,
  mavIAFoodContaminationByANonHazardousObject: 1002004,
  mavIAFatalFoodPoisoning: 1003001,
  mavIAFatalMassFoodPoisoning: 1003002,
  mavIAMassFoodPoisoningRequiringMedicalAssistance: 1003003,
  mavIAFoodPoisoningRequiringMedicalAssistance: 1003004,
  mavIAUnderOrOvercookedAnimalProduct: 1004001,
  mavIAUnderOrOvercookedFoodNonAnimalProductAndOther: 1004002,
  mavIASpoiledFood: 1005001,
  mavIAExpiredProduct: 1006001,
  mavIASeriousCrimeByMerchant: 1007001,
  mavIAHarassmentByMerchant: 1008001,
  mavIAAppAndInStorePricingDontMatch: 1009001,
  mavIAItemIsntOrDoesntWorkAsAdvertised: 1010001,
  mavIASpillageMessyOrDamagedPackaging: 2001001,
  mavIAFakeCompletionOfOrder: 2002001,
  mavIAReligiousRestrictionsViolated: 2003001,
  mavIADidntFollowCustomerInstructions: 2003002,
  mavIASollicitingCustomers: 2004001,
  mavIAColdFood: 2005001,
  mavIASoggyFood: 2006001,
  mavIAFoodNotTasty: 2007001,
  mavIAMissingItems: 2008001,
  mavIAWrongItems: 2008002,
  mavIAStoreClosed: 3001001,
  mavIAStoreTooBusy: 3001002,
  mavIAStoreClosingSoon: 3001003,
  mavIAProductsUnavailable: 3002001,
  mavIAExceedsTargetPrepTime: 4001001,
} as const
